module.exports = __webpack_public_path__ + "static/media/wrong-ipv-one.236caedf.svg";